import {
  uniqueNamesGenerator,
  adjectives,
  colors,
  animals,
} from "unique-names-generator";

// Generates a human-friendly call code like "brave-blue-tiger".
// ~1400 adjectives x ~50 colors x ~350 animals ≈ 24M combinations.
// Collisions are handled at registration time (peer.ts retries on conflict).
export function makeCode(): string {
  return uniqueNamesGenerator({
    dictionaries: [adjectives, colors, animals],
    separator: "-",
    length: 3,
    style: "lowerCase",
  });
}

// Normalizes user-typed input into a comparable code:
// trims, lowercases, collapses spaces/underscores to hyphens.
export function normalizeCode(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

const CODE_RE = /^[a-z]+-[a-z]+-[a-z]+$/;

export function isValidCode(code: string): boolean {
  return CODE_RE.test(code);
}
